import React from 'react';

import './table-heading.scss';

export type TableHeadingProps = {
  heading: string;
};

const TableHeading: React.FC<TableHeadingProps> = ({ heading }: TableHeadingProps) => {
  return <th>{heading}</th>;
};

export default TableHeading;
